import {calcStampsTimes, toHMS} from "./timeTracking";
import {useInterval} from "./hooks";
import './Time.css'


function TimeText({loading, time, timeClassName = ''}) {
    const wt = toHMS(time)
    if (loading) {
        return <div className="d-flex justify-content-center"><span className="loader align-content-center"></span></div>
    }
    return (
        <h1 className={`text-center time ${timeClassName}`}>{wt.hours < 10 ? '0' : ""}{wt.hours.toString()}:{wt.minutes < 10 ? '0' : ""}{wt.minutes.toString()}:{wt.seconds < 10 ? '0' : ""}{wt.seconds.toString()}</h1>
    )
}

function Time({loading, status, time, setTime, startWork, startBreak, stopWork, setSampNote}) {
    useInterval(() => {
        if (!status) {
            return
        }
        if (status.statusCode === 'WORK') {
            const {workTime} = calcStampsTimes(status.stamps)
            setTime(workTime)
        }
        if (status.statusCode === 'BREAK') {
            const {breakTime} = calcStampsTimes(status.stamps)
            setTime(breakTime)
        }
    }, 100)

    const _setSampNote = () => {
        if (!Array.isArray(status?.stamps) || status.stamps.length === 0) {
            return;
        }
        const currentStamp = status.stamps[status.stamps.length - 1];
        const note = prompt('Enter a note', currentStamp.note || '');
        if (note === null) {
            return
        }
        setSampNote(currentStamp.clockInTimestamp, currentStamp.timestamp, note);
    }
    if (!status || status.statusCode === 'OFF') {
        return (
            <div className="vstack gap-1 justify-content-center">
                <TimeText loading={loading} time={0} timeClassName={"text-secondary"}/>
                <div className="hstack gap-1 d-flex justify-content-center">
                    <button className="button middle" onClick={startWork} disabled={loading}>
                        <img src="/images/start.svg" className="" alt=""/>
                    </button>
                </div>
            </div>
        )
    }
    return (
        <div className="vstack gap-1 d-flex justify-content-center">
            {status.statusCode === 'WORK' && (
                <>
                    <TimeText loading={loading} time={time}/>
                    <div className="hstack gap-1 d-flex justify-content-center">
                        <button className="button middle" onClick={startBreak} disabled={loading}>
                            <img src="/images/pause.svg" className="" alt=""/>
                        </button>
                        <button className="button middle pen" onClick={_setSampNote} disabled={loading}>
                            <img src="/images/pen.svg" className="" alt=""/>
                        </button>
                        <button className="button middle" onClick={stopWork} disabled={loading}>
                            <img src="/images/stop.svg" className="" alt=""/>
                        </button>
                    </div>
                </>
            )}
            {status.statusCode === 'BREAK' && (
                <>

                    <TimeText loading={loading} time={time} timeClassName="text-warning"/>
                    <div className="hstack gap-1 d-flex justify-content-center">
                        <button className="button middle" onClick={startWork} disabled={loading}>
                            <img src="/images/start.svg" className="" alt=""/>
                        </button>
                        <button className="button middle pen" disabled={true}>
                            <img src="/images/pen.svg" className="" alt=""/>
                        </button>
                        <button className="button middle" onClick={stopWork} disabled={loading}>
                            <img src="/images/stop.svg" className="" alt=""/>
                        </button>
                    </div>
                </>)
            }
        </div>
    )
}

export default Time